/* BOLODOO promotional media v1 */
(() => {
  if (customElements.get('promotional-media')) return;
  class PromotionalMedia extends HTMLElement {
    connectedCallback() {
      if (this.closest('floated-form, .product__sticky, [data-sticky-cart]')) { this.remove(); return; }
      if (this.initialized) return;
      this.links = [...this.querySelectorAll('.promotional-media__open')];
      this.dialog = this.querySelector('dialog');
      if (!this.links.length || !this.dialog) { this.remove(); return; }
      this.initialized = true;
      this.stage = this.querySelector('.promotional-media__stage');
      this.muteButton = this.querySelector('.promotional-media__mute');
      this.closeButton = this.querySelector('.promotional-media__close');
      this.previous = this.querySelector('.promotional-media__previous');
      this.next = this.querySelector('.promotional-media__next');
      this.addEventListener('click', event => {
        const link = event.target.closest('.promotional-media__open');
        if (!link || !this.contains(link) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !this.dialog.showModal) return;
        event.preventDefault(); this.opener = link;
        this.show(this.links.indexOf(link));
        this.dialog.showModal();
        this.playCurrent();
        this.closeButton.focus();
      });
      this.closeButton.addEventListener('click', () => this.dialog.close());
      if (this.muteButton) this.muteButton.addEventListener('click', () => {
        const video = this.stage.querySelector('video');
        if (!video) return;
        video.muted = !video.muted;
        this.updateMuteButton();
      });
      this.previous.addEventListener('click', () => this.show(this.index - 1));
      this.next.addEventListener('click', () => this.show(this.index + 1));
      this.dialog.addEventListener('keydown', event => {
        if (event.target.tagName !== 'VIDEO' && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
          event.preventDefault(); this.show(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
        if (event.key === 'Tab') {
          const controls = [...this.dialog.querySelectorAll('button:not([disabled]):not([hidden]), video')];
          const first = controls[0], last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => { this.stop(); this.opener?.focus({ preventScroll: true }); });
    }
    stop() {
      const video = this.stage?.querySelector('video');
      if (video) {
        if (document.fullscreenElement === video) document.exitFullscreen?.().catch(() => {});
        if (video.webkitDisplayingFullscreen && video.webkitExitFullscreen) video.webkitExitFullscreen();
        video.pause(); video.removeAttribute('src'); video.load();
      }
      this.stage?.replaceChildren();
    }
    updateMuteButton() {
      const video = this.stage?.querySelector('video');
      if (!video || !this.muteButton) return;
      this.muteButton.querySelector('.promotional-media__sound-icon')?.classList.toggle('is-muted', video.muted);
      this.muteButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    }
    playCurrent() {
      const video = this.stage?.querySelector('video');
      if (!video) return;
      const play = () => video.play().catch(() => {});
      if (video.readyState >= 1) play();
      else video.addEventListener('loadedmetadata', play, { once: true });
    }
    show(index) {
      if (index < 0 || index >= this.links.length) return;
      this.stop(); this.index = index;
      const link = this.links[index], video = document.createElement('video');
      video.controls = true; video.autoplay = true; video.muted = true; video.loop = true; video.playsInline = true; video.preload = 'metadata';
      video.poster = link.dataset.preview; video.src = link.href;
      video.setAttribute('aria-label', link.dataset.caption || 'Product video');
      const error = this.querySelector('.promotional-media__error'); error.hidden = true;
      video.addEventListener('error', () => { if (video.isConnected) error.hidden = false; });
      this.stage.replaceChildren(video);
      this.updateMuteButton();
      this.querySelector('.promotional-media__caption').textContent = link.dataset.caption || '';
      this.querySelector('.promotional-media__count').textContent = `${index + 1} / ${this.links.length}`;
      this.previous.disabled = index === 0; this.next.disabled = index === this.links.length - 1;
    }
    disconnectedCallback() { if (this.dialog?.open) this.dialog.close(); this.stop(); }
  }
  customElements.define('promotional-media', PromotionalMedia);
})();
